import { PrescricaoPrescritorRelatorioFiltroDTO } from "@/interfaces/prescriptor-prescriptions-report";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";
import { AxiosResponse } from "axios";

export function listDataPrescriptorPrescriptionsReport(filters: PrescricaoPrescritorRelatorioFiltroDTO): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.PRESCRIPTOR_PRESCRIPTIONS_REPORT, filters),
  ).pipe(map((r: any) => r.data || {}));
}

export function buildPrescriptorPrescriptionsXlsReport(filters: PrescricaoPrescritorRelatorioFiltroDTO): Observable<AxiosResponse> {
  return from(
    apiClient.download(ENDPOINTS.PRESCRIPTOR_PRESCRIPTIONS_REPORT_XLS, filters),
  );
}